import React from "react";
import MuiChip from "@mui/material/Chip";
import clsx from "clsx";

import { ChipProps } from "./Chip.types";
import { useStyles } from "./Chip.styles";
import CloseIcon from "@tiny/icons/generated/CloseBig";

function Chip(props: ChipProps, ref: React.ForwardedRef<HTMLDivElement>) {
  const { color, textColor, className, size, ...other } = props;

  const classes = useStyles(props);

  const classNames = clsx(
    classes.root,
    {
      [classes.colorPrimary]: color === "primary",
      [classes.colorRed]: color === "red",
      [classes.colorfuchsia]: color === "fuchsia",
      [classes.colorYellow]: color === "yellow",
      [classes.colorBlue]: color === "blue",
      [classes.colorGreen]: color === "green",
      [classes.colorPurple]: color === "purple",
      [classes.colorBlack]: color === "black",
      [classes.colorGrey]: color === "grey",

      [classes.textColorPrimary]: textColor === "primary",
      [classes.textColorRed]: textColor === "red",
      [classes.textColorfuchsia]: textColor === "fuchsia",
      [classes.textColorYellow]: textColor === "yellow",
      [classes.textColorBlue]: textColor === "blue",
      [classes.textColorGreen]: textColor === "green",
      [classes.textColorPurple]: textColor === "purple",
      [classes.textColorBlack]: textColor === "black",
      [classes.textColorGrey]: textColor === "grey",
      [classes.sizeSmall]: size === "small",
      [classes.sizeTiny]: size === "tiny",
    },
    className
  );

  return (
    <MuiChip
      {...other}
      className={classNames}
      ref={ref}
      deleteIcon={<CloseIcon className={classes.icon} />}
    />
  );
}

export default React.forwardRef(Chip);
